import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import Routes from './Routes';
import Header from '../shared/header/Header';
import LeftNavBar from '../shared/left-bar/Left-bar';
import Login from './auth/login/Login';
import { CommonUtils, FTL_WALKTHROUGH_COMPLETED, USER } from '../constants/CommonConst';
import FirstTimeLoginWalkthrough from '../components/first-time-login-walkthrough/First-Time-Login-Walkthrough';
import AuthLayout from './auth/layout/Auth-Layout';
import SetNewPassword from './auth/set-new-password/Set-New-Password';
import ForgotPassword from './auth/forgot-password/Forgot-Password';
import AccessDenied from './access-denied/Access-denied';
import { decryptLocalStorage, startSessionValidationJob, stopSessionValidationJob, startIdleTimeoutTracker, stopIdleTimeoutTracker } from '../utils/authUtils';
import Loader from '../shared/loader/Loader';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PreLogin from './auth/pre-login/Pre-Login';
import SessionExpiredModal from '../shared/session-expired-modal/Session-Expired-Modal';

function MainLayout() {
  const loaderCount = useSelector((state) => state?.loader?.count);
  const [isExpanded, setExpanded] = useState(true);
  const firstTimeLoggedWalkthroughCompleted = decryptLocalStorage(FTL_WALKTHROUGH_COMPLETED);
  const loggedinUser = decryptLocalStorage(USER);
  const leftMenu = CommonUtils.getLeftMenu();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const onCollapse = (status) => {
    setExpanded(status);
  };

  useEffect(() => {
    if (loggedinUser) {
      startSessionValidationJob(history, 60000);
      startIdleTimeoutTracker(history);
    } else {
      history.push('/prelogin');
    }
    return () => {
      stopSessionValidationJob();
      stopIdleTimeoutTracker();
    };
  }, [history, loggedinUser]);

  if (!loggedinUser) {
    return null;
  }

  return (
    <div className='h-100'>
      <SessionExpiredModal />
      {loaderCount > 0 && <Loader />}
      {Array.isArray(firstTimeLoggedWalkthroughCompleted) &&
      firstTimeLoggedWalkthroughCompleted?.some(
        (completedUsers) => completedUsers === loggedinUser?.id,
      ) ? (
        <div className={`d-flex h-100 mx-0 content ${loaderCount > 0 ? 'blur' : ''}`}>
          <div
            className={` ${
              isExpanded ? 'left-side-bar' : 'left-side-bar-collapsed'
            } px-0 h-100 left-container`}
          >
            <LeftNavBar
              leftMenu={leftMenu}
              onColapse={onCollapse}
              expanded={isExpanded}
            ></LeftNavBar>
          </div>
          <div className='right-side-content ps-2 h-100'>
            <Header setLoading={setLoading} />
            <Routes setLoading={setLoading} />
          </div>
        </div>
      ) : (
        <div className='mx-0 bg-white'>
          <FirstTimeLoginWalkthrough></FirstTimeLoginWalkthrough>
        </div>
      )}
    </div>
  );
}

function RenderRoutes() {
  return (
    <Switch>
      <AuthLayout path='/prelogin' component={PreLogin} />
      <AuthLayout path='/login' component={Login} />
      <AuthLayout path='/set-password' component={SetNewPassword} />
      <AuthLayout path='/forgot-password' component={ForgotPassword} />
      <AuthLayout path='/access-denied' component={AccessDenied} />
      <Route path={`/`} component={MainLayout} />
    </Switch>
  );
}

export default RenderRoutes;
